import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { InsectaServiceBase } from './insecta.base.service';
import { IEmailRequest } from './insecta.models';

@Injectable({
  providedIn: 'root'
})
export class EmailService extends InsectaServiceBase {
  public sendEmail(request: IEmailRequest): Observable<void> {
    return this.post<void>(`/email/`, `v1`, request);
  }
}
